import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-85">
      {children}
    </motion.div>;
}